import ProgrammeCard from '../ProgrammeCard';
import programmesOffered from "../Programmes.json";
import "./pgProgrammes.scss";
import { Link, Outlet, useParams } from 'react-router-dom';

import maEnglish from "../../assets/Academics/PG Cards Thumbnails/MAEnglish.jpeg";
import mCom from "../../assets/Academics/PG Cards Thumbnails/MCom.jpeg";
import mscBioTechnology from "../../assets/Academics/PG Cards Thumbnails/MSc_Bio_Technology.JPG";
import mscMaths from "../../assets/Academics/PG Cards Thumbnails/MSc_Mathematics.jpeg";
import mscComputerScience from "../../assets/Academics/PG Cards Thumbnails/MSc_Computer_Science.JPG";

const PG_Programmes = () => {

    const { courseName } = useParams();
    const pgThumbnailImages = {
        "maEnglish": maEnglish,
        "mCom": mCom,
        "mscMaths": mscMaths,
        "mscComputerScience": mscComputerScience,
        "mscBioTechnology": mscBioTechnology
    };

    return (
        <section className="pgProgrammesPageMainParent">
            {courseName ? (
                <Outlet />
            ) : (
                <>
                    <article className="pgProgrammesParent">
                        <header style={{ width: "100%" }}>
                            <h2>PG Programmes</h2>
                        </header>
                        <article className="pgProgrammesOffered">
                            {programmesOffered.pgProgrammes.map((course, index) => (
                                <Link key={index} to={course.route} style={{ textDecoration: "none", display: "flex", justifyContent: "center" }}>
                                    <ProgrammeCard bgImage={pgThumbnailImages[course.thumbNailImage]} course={course.course} />
                                </Link>
                            ))}
                        </article>
                    </article>
                </>
            )}
        </section>
    )
}

export default PG_Programmes
